import { LucideCheck, LucideX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Modal } from "./Modal";

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {() => void} props.onConfirm
 * @param {boolean} props.saving
 * @param {string} props.saveError
 * @param {Array<{ step: string, fields: Array<{ key: string, label: string, value: string }> }>} props.byStep
 */
export function ReportDefaultsConfirmModal({ open, onClose, onConfirm, saving, saveError, byStep }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Confirm Default Values"
      subtitle="The following values will be written to all existing reports in this Report Folder."
      preventClose={saving}
    >
      {/* Field list */}
      <div className="flex-1 overflow-y-auto px-6 py-4 space-y-5">
        {byStep.length === 0 ? (
          <p className="text-sm text-muted-foreground">No values to save. Fill in at least one field first.</p>
        ) : (
          byStep.map(({ step, fields }) => (
            <div key={step}>
              <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-2 pb-1 border-b border-border">
                {step}
              </p>
              <ul className="space-y-1.5">
                {fields.map(({ key, label, value, clearing }) => (
                  <li key={key} className="flex items-start gap-2 text-sm">
                    {clearing ? (
                      <LucideX size={14} className="shrink-0 mt-0.5 text-destructive" />
                    ) : (
                      <LucideCheck size={14} className="shrink-0 mt-0.5 text-info-fg" />
                    )}
                    <span>
                      <span className="font-medium text-foreground">{label}:</span>{" "}
                      {clearing ? (
                        <span className="text-destructive line-through">{value}</span>
                      ) : (
                        <span className="text-muted-foreground">{value}</span>
                      )}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))
        )}
      </div>

      {/* Footer */}
      <div className="px-6 pb-5 pt-4 border-t border-border shrink-0 space-y-3">
        {saveError && <p className="text-sm text-destructive">{saveError}</p>}
        <div className="flex gap-2">
          <Button variant="outline" className="flex-1" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button className="flex-1" onClick={onConfirm} disabled={saving || byStep.length === 0}>
            {saving ? "Saving…" : "Apply to All Reports"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
